import UserAvatar from "../components/global/avtar/UserAvatar";

const columns = [
    // {
    //     title: "User",
    //     dataIndex: "user",
    //     render: (_, record) => (
    //         <UserAvatar
    //             data={{
    //                 name: record?.fullName,
    //                 email: record?.email,
    //                 profileImage: record?.profilePic,
    //             }}
    //         />
    //     ),
    // },
    {
        title: 'Message',
        dataIndex: 'message',
       
    },
 
    {
        title: 'Created Date',
        dataIndex: 'createdDate',
       
    },
   
];


export default columns;